import { styled } from 'styled-system/jsx'

const FormColumn = styled('form', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    width: '100%',
  },
})

const FieldGroup = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
})

const FieldLabel = styled('label', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: 600,
    color: 'app.fgMuted',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
})

const FieldInput = styled('input', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    padding: '10px 12px',
    border: '1px solid',
    borderColor: 'app.border',
    borderRadius: 'md',
    backgroundColor: 'app.surface',
    color: 'app.fg',
    _focus: {
      outline: 'none',
      borderColor: 'app.accent',
      boxShadow: '0 0 0 3px rgba(31, 111, 235, 0.15)',
    },
    _placeholder: {
      color: 'book.inkMuted',
    },
  },
})

const FieldTextarea = styled('textarea', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    padding: '10px 12px',
    border: '1px solid',
    borderColor: 'app.border',
    borderRadius: 'md',
    backgroundColor: 'app.surface',
    color: 'app.fg',
    minHeight: '88px',
    resize: 'vertical',
    _focus: {
      outline: 'none',
      borderColor: 'app.accent',
      boxShadow: '0 0 0 3px rgba(31, 111, 235, 0.15)',
    },
    _placeholder: {
      color: 'book.inkMuted',
    },
  },
})

const ErrorBanner = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'book.danger',
    backgroundColor: '#FEE2E2',
    border: '1px solid',
    borderColor: 'book.danger',
    borderRadius: 'md',
    padding: '8px 12px',
  },
})

const ButtonRow = styled('div', {
  base: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'flex-end',
    marginTop: '4px',
  },
})

const SecondaryButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: 500,
    padding: '10px 16px',
    border: '1px solid',
    borderColor: 'app.border',
    borderRadius: 'md',
    backgroundColor: 'app.surface',
    color: 'app.fg',
    cursor: 'pointer',
    _hover: { backgroundColor: 'book.surfaceMuted' },
    _disabled: { opacity: 0.5, cursor: 'not-allowed' },
  },
})

const PrimaryButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: 600,
    padding: '10px 20px',
    border: 'none',
    borderRadius: 'md',
    backgroundColor: 'app.accent',
    color: 'white',
    cursor: 'pointer',
    _hover: { backgroundColor: 'app.accentHover' },
    _disabled: { opacity: 0.5, cursor: 'not-allowed' },
  },
})

const AddAttendeeButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: 500,
    color: 'app.accent',
    backgroundColor: 'transparent',
    border: '1px dashed',
    borderColor: 'app.border',
    borderRadius: 'md',
    padding: '8px 12px',
    cursor: 'pointer',
    width: 'fit-content',
    _hover: { backgroundColor: 'app.surface' },
    _disabled: { opacity: 0.5, cursor: 'not-allowed' },
  },
})

const AttendeeRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
})

const RemoveAttendeeButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'app.fgMuted',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '4px 8px',
    borderRadius: 'sm',
    _hover: { color: 'app.fg' },
  },
})

const RecurringCard = styled('label', {
  base: {
    display: 'flex',
    gap: '12px',
    padding: '12px 14px',
    border: '1px solid',
    borderColor: 'app.border',
    borderRadius: 'md',
    backgroundColor: 'app.surface',
    cursor: 'pointer',
    fontFamily: 'body',
    fontSize: '13px',
    color: 'app.fg',
    alignItems: 'flex-start',
  },
})

const RecurringCheckbox = styled('input', {
  base: {
    marginTop: '2px',
    cursor: 'pointer',
  },
})

const RecurringCopy = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
})

const RecurringTitle = styled('span', {
  base: {
    fontWeight: 600,
    color: 'app.fg',
  },
})

const RecurringDetail = styled('span', {
  base: {
    color: 'app.fgMuted',
    fontSize: '12px',
  },
})

export {
  FormColumn,
  FieldGroup,
  FieldLabel,
  FieldInput,
  FieldTextarea,
  ErrorBanner,
  ButtonRow,
  SecondaryButton,
  PrimaryButton,
  AddAttendeeButton,
  AttendeeRow,
  RemoveAttendeeButton,
  RecurringCard,
  RecurringCheckbox,
  RecurringCopy,
  RecurringTitle,
  RecurringDetail,
}
